:host {
  display: block;

  .pulse-danger {
    display: block;
    border-radius: 50%;
    @include animate(pulse-shadow, 2s, infinite, linear);
  }
  .error {
    background-color: var(--av-color-danger);
    padding: 5px;
    font-size: 0.8em;
    margin-top: 5px;
    max-width: 200px;
    position: absolute;
    right: 0;
    min-width: 170px;
    color: var(--av-color-danger-contrast);
    border-radius: 5px;
  }
}

av-asset {
  width: 100%;
}

av-button {
  --av-border-radius-button: 30px;
}

@include pulse-shadow(var(--av-color-danger));
